module.exports = __webpack_public_path__ + "static/media/ComplainAnswer.c027ea8b.svg";